import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  margin-top: 0; 
  padding: 0;
  background-color: #F8F8F8;
  opacity: 1;
  width: 100%;
  box-shadow: none;

  .ant-card {
    border-radius: 8px;
    box-shadow: none;
    border: 1px solid #f0f0f0;
  }

  .ant-card-body {
    padding: 16px;
  }

  .ant-statistic-title {
    margin-bottom: 0px;
    color: #929292;
    font-size: 14px;
  }

  .ant-statistic-content {
    font-size: 24px;
    font-weight: 600;
    color: #000;
  }

  .metrics-card {
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      background-color: #f8f9fa;
    }
  }

  .form-list-item {
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      background-color: #f8f9fa;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateY(-2px);
    }
  }

  .progress-bar {
    height: 8px;
    border-radius: 4px;
    background-color: #f0f0f0;
    overflow: hidden;
    
    .progress-fill {
      height: 100%;
      background: linear-gradient(90deg, #4085c6, #60a5fa);
      border-radius: 4px;
      transition: width 0.3s ease;
    }
  }

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    margin-right: 16px;
  }

  .metric-value {
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 4px;
  }

  .metric-label {
    font-size: 14px;
    color: #666;
    font-weight: 500;
  }

  .metric-description {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }

  .ant-divider {
    margin: 24px 0;
  }

  .ant-typography h3 {
    color: #000;
    font-weight: 600;
  }

  .ant-typography h5 {
    color: #000;
    font-weight: 600;
    margin-bottom: 16px;
  }

  .ant-btn-primary {
    background-color: #4085c6;
    border-color: #4085c6;
    
    &:hover {
      background-color: #60a5fa;
      border-color: #60a5fa;
    }
  }

  .ant-btn {
    border-radius: 6px;
    font-weight: 500;
  }

  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
    padding: 0;
  }

  .ant-card-head-title {
    font-weight: 600;
    color: #000;
  }

  .ant-empty {
    margin: 40px 0;
  }

  .ant-empty-description {
    color: #999;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  }

  // Responsividade
  @media (max-width: 768px) {
    padding: 10px 16px 0 16px;
    
    .ant-card-body {
      padding: 16px;
    }
    
    .metric-value {
      font-size: 24px;
    }
    
    .icon-container {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }
  }

  @media (max-width: 576px) {
    padding: 8px 12px 0 12px;
    
    .ant-card-body {
      padding: 12px;
    }
    
    .metric-value {
      font-size: 20px;
    }
  }
`;

export const ContentPanel = styled.div`
  background-color: #F8F8F8; 
  opacity: 1;
  width: 100%;
  box-shadow: none;
  border-radius: 8px;
  padding: 4px;
  min-height: calc(100vh - 200px);

  .ant-table-tbody > tr > td {
    word-break: break-word !important;
    white-space: normal !important;
  }

  .ant-table-thead > tr > th {
    background-color: #fafafa;
    font-weight: 600;
    color: #000;
  }

  .ant-table-tbody > tr:hover > td {
    background-color: #f8f9fa;
  }
`;
